import CustomAudio from "@/components/CustomAudio.vue";
import {
  App,
  defineComponent,
  createApp,
  onMounted,
  nextTick,
  ref,
  onBeforeUnmount,
  Ref,
} from "vue";
import { getImageSize, getRemRate } from "@/utils/rem";

const replaceMatcher = {
  "custom-audio": {
    name: "custom-audio",
    component: CustomAudio,
    reg: (content: string) => {
      const audioExp = new RegExp("<kbd>.*?</kbd>", "g");
      const srcExp = new RegExp('src="([^"]+)');
      let match;
      while ((match = audioExp.exec(content)) !== null) {
        content = content.replace(
          '<span style="color: rgb(159, 171, 183);">请点击按钮播放</span><span style="color: black;"> </span>',
          ""
        );
        const audioStr = match[0];
        const srcList: any = srcExp.exec(audioStr);
        const src = srcList?.length > 0 ? srcList[0] : "";
        const srcNum = src.replace(`src="`, "");
        const newStr = `<div class="dv-audio"><custom-audio musicUrl="${srcNum}" /></div>`;
        content = content.replace(audioStr, newStr);
      }
      return content;
    },
  },
  "img-rem": {
    name: "img-rem",
    component: null,
    reg: async (content: string) => {
      const imgReg = new RegExp("<img.*?>", "g");
      let match;
      console.log(9991, content);
      while ((match = imgReg.exec(content)) !== null) {
        let originImg = match[0];
        const widthExp = new RegExp('width=".*"');
        const styleExp = new RegExp('style=".*;"');
        const pxExp = new RegExp(/[1-9][0-9]*/g);
        const widthStrData = widthExp.exec(originImg);
        // 获取originImg的style
        const styleStrData = styleExp.exec(originImg);
        if (styleStrData) {
          const imgStyle = new RegExp(styleStrData ? styleStrData[0] : "");
          console.log(9994, imgStyle);
          // 去除originImg中的style
          originImg = originImg.replace(imgStyle, "");
          const widthStr = widthStrData ? widthStrData[0] : "";
          let pxNumber: number;
          if (!widthStr) {
            const srcExp = new RegExp('src="([^"]+)');
            const srcList: any = srcExp.exec(originImg);
            const src = srcList?.length > 0 ? srcList[0].slice(5) : "";
            pxNumber = await getImageSize(src);
          } else {
            const px = pxExp.exec(widthStr);
            pxNumber = px ? parseFloat(px[0]) : 0;
          }
          const rate = getRemRate();
          const rem = rate * pxNumber;
          let style = "";
          let imgStyleString = imgStyle.toString();
          if (imgStyleString.length === 0) {
            // 为空的时候直接新增一个style
            style = `style="width: ${rem}rem"`;
          } else {
            // 不为空的时候在style中增加宽度的rem
            const num = imgStyleString.length - 2;
            // 去除字符串最后一个/
            imgStyleString = imgStyleString.substring(
              0,
              imgStyleString.length - 1
            );

            style =
              imgStyleString.slice(1, num) +
              ` width: ${rem}rem;` +
              imgStyleString.slice(num);
            console.log(9997, style);
          }

          if (widthStr) {
            // 把确定的style插回content中
            content = content.replace(
              match[0],
              originImg.slice(0, -1) + ` ${style}>`
            );
          } else {
            console.log("999按道理不会再进入这个地方", style, widthStr);
          }
        } else {
          console.log("999b,img不存在style");
        }
      }
      // 去掉空style
      const emptyStyleExp = new RegExp('style=""');
      const emptyStyleData = emptyStyleExp.exec(content);
      const emptyStyleStr = emptyStyleData ? emptyStyleData[0] : "";
      content = content.replace(emptyStyleStr, "");
      console.log(9998, content);

      return content;
    },
  },
};
export default (isResizeImgToRem: boolean | undefined = true) => {
  const generateTemplate = async (sourceTemplate: string) => {
    for (const matcher of Object.values(replaceMatcher)) {
      if (!isResizeImgToRem && matcher.name === "img-rem") {
        continue;
      }
      sourceTemplate = await matcher.reg(sourceTemplate);
    }
    return sourceTemplate;
  };

  const registerComponents = (app: App) => {
    Object.entries(replaceMatcher).forEach(([key, value]) => {
      if (value.component) {
        app.component(key, value.component);
      }
    });
  };

  const compileContent = async (el: HTMLElement, content: string) => {
    if (!content || !el) {
      return;
    }
    const template = await generateTemplate(content);
    const comp = defineComponent({
      template,
    });
    const app = createApp(comp);
    registerComponents(app);
    app.mount(el);
    return app;
  };

  const compileQuestionTitle = (
    el: Ref<HTMLDivElement | undefined>,
    content: string
  ) => {
    const titleApp = ref<App | null | undefined>(null);
    onMounted(async () => {
      await nextTick();
      titleApp.value = await compileContent(el.value!, content);
    });
    onBeforeUnmount(() => {
      titleApp.value && titleApp.value.unmount();
    });

    return titleApp;
  };

  return {
    generateTemplate,
    registerComponents,
    compileContent,
    compileQuestionTitle,
  };
};
